module.exports = __webpack_public_path__ + "img/C08TechRamChampion_ua.b4566f6a.webp";